<div [class]="className" [ngStyle]="styles"></div>
